"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PanThumb = _interopRequireDefault(require("@/components/PanThumb"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    PanThumb: _PanThumb.default
  },
  props: {
    user: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          avatar: ''
        };
      }
    },
    modifyPassword: {
      type: Function,
      default: function _default() {
        return;
      }
    }
  }
};